import Datepicker from 'vanillajs-datepicker/Datepicker';

export const teamDateFormat = () => {
  // the meta tag carries jQuery UI tokens (yy = 4-digit year) for the legacy
  // datepickers; vanillajs-datepicker spells the 4-digit year as yyyy
  const metaFormat = document.querySelector('meta[name="date-format"]')?.content || 'mm/dd/yy';
  return metaFormat.replace(/\byy\b/, 'yyyy');
};

const fadePastDates = (date) => {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  return date < startOfToday ? 'datepicker-past-date' : undefined;
};

export const createDatepicker = (element, options = {}) => {
  const datepicker = new Datepicker(element, {
    format: teamDateFormat(),
    autohide: true,
    todayHighlight: true,
    buttonClass: 'datepicker-nav-button',
    beforeShowDay: fadePastDates,
    ...options,
  });

  if (element instanceof HTMLInputElement) {
    element.addEventListener('show', () => {
      const caretLeft = `${element.offsetWidth / 2}px`;
      datepicker.pickerElement.style.setProperty('--datepicker-caret-left', caretLeft);
    });
  }

  return datepicker;
};

export { Datepicker };
